import React from 'react';
import { Navbar as BSNavbar, Nav, Container, Badge, Button } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import { FaLinkedin } from 'react-icons/fa';
import AuthStatus from './AuthStatus';
import { isAdmin } from '../services/authService';

const Navbar = () => {
  const location = useLocation();
  
  return (
    <BSNavbar bg="dark" variant="dark" expand="lg">
      <Container fluid>
        <BSNavbar.Brand as={Link} to="/dashboard">
          SGV Dashboard
          <Badge bg="secondary" className="ms-2">v1.0</Badge>
        </BSNavbar.Brand>
        <BSNavbar.Toggle aria-controls="basic-navbar-nav" />
        <BSNavbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link 
              as={Link} 
              to="/" 
              active={location.pathname === '/'}
            >
              Reporte de Avisos
            </Nav.Link>
            <Nav.Link 
              as={Link} 
              to="/comparativa-ventas" 
              active={location.pathname === '/comparativa-ventas'}
            >
              Comparativa de Ventas
            </Nav.Link>
            <Nav.Link 
              as={Link} 
              to="/dashboard" 
              active={location.pathname === '/dashboard'}
            >
              <i className="bi bi-speedometer2 me-1"></i> Dashboard Comercial
            </Nav.Link>
            <Nav.Link 
              as={Link} 
              to="/evolucion-clientes" 
              active={location.pathname === '/evolucion-clientes'}
            >
              <i className="bi bi-people me-1"></i> Evolución Clientes
            </Nav.Link>
            {isAdmin() && (
              <>
                <Nav.Link 
                  as={Link} 
                  to="/gestion-usuarios" 
                  active={location.pathname === '/gestion-usuarios'}
                >
                  <i className="bi bi-person-gear me-1"></i> Gestión de Usuarios
                </Nav.Link>
                <Nav.Link 
                  as={Link} 
                  to="/crear-usuario" 
                  active={location.pathname === '/crear-usuario'}
                >
                  <i className="bi bi-person-plus me-1"></i> Crear Usuario
                </Nav.Link>
              </>
            )}
          </Nav>
          <div className="d-flex align-items-center me-3">
            <span className="text-light me-2">Desarrollado por:</span>
            <Button 
              size="sm"
              variant="outline-primary" 
              className="me-1" 
              href="https://www.linkedin.com/in/benjam%C3%ADn-labb%C3%A9-0b1814251/" 
              target="_blank" 
              rel="noopener noreferrer"
              title="Benjamin Labbé"
            >
              <FaLinkedin className="me-1" />
              Benjamin
            </Button>
            <Button 
              size="sm"
              variant="outline-primary" 
              href="https://www.linkedin.com/in/fcolabbe/" 
              target="_blank" 
              rel="noopener noreferrer"
              title="Francisco Labbé"
            >
              <FaLinkedin className="me-1" />
              Francisco
            </Button>
          </div>
          <AuthStatus />
        </BSNavbar.Collapse>
      </Container>
    </BSNavbar>
  );
};

export default Navbar; 